/**
 * Sleep for "ms" milliseconds.
 *
 * @param {*} ms
 * @returns
 */
export const sleep = (ms: number) => {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
};

/**
 * Replaces all links in the given text with links that have the "text"
 * query parameter set to the link text.
 *
 * @param {string} text
 * @returns {string}
 */
export const formatLink = (text: string) => {
	const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
	return text?.replace(linkRegex, (_, linkText, url) => {
		const hasQuery = url.includes("?") || url.includes("&");
		const queryChar = hasQuery ? "&" : "?";
		const finalUrl = url.replace('#!', '');
		return `${finalUrl}${queryChar}text=${encodeURIComponent(linkText)}`;
	}) || "";
};
